import { z } from 'zod';
import { TabelaPrecoProdutoPartialSchema } from '@/features/tabela-preco/types/TabelaPrecoProdutoPartial';
import { TabelaComissaoTipo } from './enum';

const TabelaComissaoProdutoExcecaoSchema = z.object({
    tce_idpk: z.number().nullable(),
    tce_percentual: z.number().nullable(),
});

export const TabelaComissaoProdutoSchema = z.object({
    produto: TabelaPrecoProdutoPartialSchema,
    tabela_comissao_excecao: TabelaComissaoProdutoExcecaoSchema.nullable(),
    tac_descricao: z.string().nullable(),
    tac_empresa_idpk: z.number(),
    tac_idpk: z.number(),
    tac_percentual: z.number(),
    tac_tipo: z.enum(TabelaComissaoTipo),
    tac_ultima_alteracao: z.string().nullable(),
});

export type TabelaComissaoProduto = z.infer<typeof TabelaComissaoProdutoSchema>;
